export const BASE_HEIGHT = 524;
export const BASE_WIDTH = 840;
export const BASE_CONTEMT_WIDTH = 720;
export const BASE_CONTEMT_HEIGHT = 405;
export const BASE_PADDING = 60;
export const BASE_GAP = 48;
export const BASE_ADD_ICON_SIZE = 48;
export const BASE_SIDE_ADD_ICON_SIZE = 32;
export const BASE_SIDE_ADD_ICON_PLUS_SIZE = 14;
